import { type } from '@/utils/type'


export const ENSEIGNE_REQUEST = type('ENSEIGNE_REQUEST')
export const ENSEIGNE_SUCCESS = type('ENSEIGNE_SUCCESS')
export const ENSEIGNE_ERROR = type('ENSEIGNE_ERROR')

export const ENSEIGNE_ENSURE_LIST = type('ENSEIGNE_ENSURE_LIST')

export const ENSEIGNE_SELECT_DETAIL_REQUEST = type('ENSEIGNE_SELECT_DETAIL_REQUEST')
export const ENSEIGNE_SELECT_DETAIL_SUCCESS = type('ENSEIGNE_SELECT_DETAIL_SUCCESS')
export const ENSEIGNE_SELECT_DETAIL_ERROR = type('ENSEIGNE_SELECT_DETAIL_ERROR')
export const ENSEIGNE_SELECT_DETAIL = type('ENSEIGNE_SELECT_DETAIL')

export const ENSEIGNE_SAVE_REQUEST = type('ENSEIGNE_SAVE_REQUEST')
export const ENSEIGNE_SAVE_SUCCESS = type('ENSEIGNE_SAVE_SUCCESS')
export const ENSEIGNE_SAVE_ERROR = type('ENSEIGNE_SAVE_ERROR')

export const ENSEIGNE_UPDATE_MODIFIED_ADM = type('ENSEIGNE_UPDATE_MODIFIED_ADM')
export const ENSEIGNE_CANCEL_MODIFIED_ADM = type('ENSEIGNE_CANCEL_MODIFIED_ADM')

export const ENSEIGNE_UPDATE_FILTER_ADM = type('ENSEIGNE_UPDATE_FILTER_ADM')